import { render, staticRenderFns } from "./legal-urge-action-flow.vue?vue&type=template&id=2f7e659a&scoped=true"
import script from "./legal-urge-action-flow.vue?vue&type=script&lang=ts"
export * from "./legal-urge-action-flow.vue?vue&type=script&lang=ts"
import style0 from "./legal-urge-action-flow.vue?vue&type=style&index=0&id=2f7e659a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e659a",
  null
  
)

export default component.exports